import { Filter } from "@/components/filter/_types";

export interface FilterListProps {
  filters: Filter<unknown, unknown>[];
  currentFilterValues: Record<string, string[]>;
  onFilterChange: (filterId: string, values: string[]) => void;
}

export function FilterList({ filters, currentFilterValues, onFilterChange }: FilterListProps) {
  return filters.map((filter) => (
    <div key={filter.id}>
      {filter.render({
        selectedValues: currentFilterValues[filter.id] ?? [],
        showBadges: false,
        onSelectionChange: (values) => onFilterChange(filter.id, values),
      })}
    </div>
  ));
}
